<agr-page [pageTitle]="'labresults.title' | translate">
  <div class="overview__content">
    <agr-form [formGroup]="form" class="flex--gutter-container">
      <div class="flex--row flex--align-center">
        <mat-form-field appearance="outline" class="labresult__search-input">
          <input
            matInput
            formControlName="search"
            placeholder="{{ 'labresults.searchPlaceholder' | translate }}"
            (keydown.escape)="clearSearchbox()"
            (keydown.enter)="searchLabResults()"
            (keyup)="searchLabResults()"
          />
          <button mat-icon-button matIconSuffix (click)="clearSearchbox()" type="button">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </agr-form>
    <div class="labresults-table">
      @if (nutrientCategories?.length > 0) {
        <div class="labresults-table__tabs">
          <mat-tab-group
            class="labresults-table__tabs--group"
            [mat-stretch-tabs]="false"
            (selectedIndexChange)="updateSelectedNutrientCategory($event)"
          >
            @for (nutrientCategory of nutrientCategories; track nutrientCategory) {
              <mat-tab [label]="'labresults.nutrient-category.' + nutrientCategory.key | translate">
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      }

      <div class="labresults-table__table">
        <table mat-table [dataSource]="dataSource">
          @for (column of columndefs; track column; let i = $index) {
            <ng-container [matColumnDef]="column">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="labresults-table__table--header labresults-table__table--column"
              >
                @if (column !== 'hasReport') {
                  <div class="labresults-table__table--header-title">
                    {{ 'labresults.header.' + column | translate }}
                  </div>
                }
              </th>
              <td mat-cell *matCellDef="let labresult" class="labresults-table__table--column">
                @if (column === 'descriptionAndId') {
                  <div>
                    {{ labresult.description }}
                    <span class="labresults-table__table--description-id">{{
                      labresult.labResultId
                    }}</span>
                  </div>
                }
                @if (column === 'hasReport' && labresult.hasReport) {
                  <div>
                    <button
                      mat-icon-button
                      matIconSuffix
                      (click)="downloadReport(labresult.id)"
                      type="button"
                    >
                      <mat-icon>attach_file</mat-icon>
                    </button>
                  </div>
                }
                @if (column !== 'descriptionAndId' && column !== 'hasReport') {
                  <div>
                    {{ labresult[column] | translate }}
                  </div>
                }
              </td>
            </ng-container>
          }
          @for (column of selectedNutrientCategory?.nutrients; track column; let i = $index) {
            <ng-container [matColumnDef]="column.id + ''">
              <th mat-header-cell *matHeaderCellDef class="labresults-table__table--column">
                <div class="labresults-table__table--column-header">
                  <p>{{ column.designation }}</p>
                  <p>{{ column.unit }}</p>
                  <p></p>
                </div>
              </th>
              <td mat-cell *matCellDef="let element" class="labresults-table__table--column">
                @if (
                  element.nutrients[i] !== undefined && element.nutrients[i].value !== undefined
                ) {
                  <span>
                    {{ element.nutrients[i].value | agrNumber: element.nutrients[i].format }}
                  </span>
                }
                @if (
                  element.nutrients[i] === undefined || element.nutrients[i].value === undefined
                ) {
                  <span>-</span>
                }
              </td>
            </ng-container>
          }

          <tr mat-header-row *matHeaderRowDef="allDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: allDisplayedColumns"></tr>
        </table>
      </div>
    </div>
    @if (paginatorSettings) {
      <mat-paginator
        [length]="paginatorSettings.length"
        [pageSize]="paginatorSettings.pageSize"
        [pageIndex]="paginatorSettings.pageIndex"
        [pageSizeOptions]="[5, 10, 20, 25]"
        (page)="reloadLabResults($event)"
        showFirstLastButtons
      >
      </mat-paginator>
    }
  </div>
</agr-page>
